import {useEffect, useState, useRef} from 'react'
import {UserModel} from '../../auth'
import {getMonthlyServiceInfo} from '../core/_requests'
import {IMonthlyServiceBody} from '../core/_models'
import {useIntl} from 'react-intl'
import {Tooltip} from 'bootstrap'

type Props = {
  className: string
  language: string
  currentUser: UserModel | undefined
}

const MonthlyServiceCard: React.FC<Props> = ({language, currentUser, className}) => {
  const {formatMessage} = useIntl()
  const [state, setState] = useState<IMonthlyServiceBody>({
    monthly_service_level: 0,
    info: '',
  })
  const tooltipTriggerRef = useRef<HTMLElement | null>(null)

  useEffect(() => {
    const getData = async () => {
      const {data} = await getMonthlyServiceInfo(currentUser?.token, language)
      if (data) {
        setState(data.data)
      }
    }
    getData()
  }, [])

  useEffect(() => {
    if (tooltipTriggerRef.current) {
      const tooltip = new Tooltip(tooltipTriggerRef.current)
      return () => {
        tooltip.dispose()
      }
    }
  }, [state.info])

  return (
    <div className={`hsb-service ${className}`}>
      <div className='hsb-service__head'>
        <h3 className='hsb-section-title'>
          {formatMessage({id: 'monthly_service_lvl'})}
          <i
            ref={tooltipTriggerRef}
            className='fas fa-exclamation-circle hsb-info-icon'
            data-bs-toggle='tooltip'
            data-bs-placement='top'
            title={state.info}
          ></i>
        </h3>
        <span className='hsb-service__pct'>{state.monthly_service_level}%</span>
      </div>
      <div className='hsb-progress'>
        <div
          className='hsb-progress__bar'
          role='progressbar'
          style={{width: `${state.monthly_service_level}%`}}
          aria-valuenow={state.monthly_service_level}
          aria-valuemin={0}
          aria-valuemax={100}
        ></div>
      </div>
    </div>
  )
}

export default MonthlyServiceCard
